export const talentList = [
  {
    id: 'linh-tran',
    initial: 'L',
    color: '#596ae8',
    name: 'Linh Tran',
    handle: '@linh.glow',
    country: '越南 Vietnam',
    category: '美妆 Beauty',
    followers: '42.6万',
    gmv30: '₫ 4.86亿',
    gmv7: '₫ 1.08亿',
    hasEmail: true,
    status: '已回复',
    statusKey: 'replied',
    favorited: true,
    matchScore: 94,
    stateLabel: '邀约已签收',
    tags: ['越南', '美妆', '已回投', '高转化', '我的达人', '合作中'],
    whyFit:
      '品类与店铺高度重合，粉丝以东南亚 18–34 岁女性为主，近 30 日 GMV 稳定。建议优先发起定向邀约并跟进样品签收。',
    timeline: [
      { time: '今天 14:08', title: '回复邮件', desc: '确认样品已发出，预计 3 日送达。' },
      { time: '昨天', title: '邮件打开', desc: '查看了 Vitamin C 商品卡。' },
      { time: '2 天前', title: '发送商品卡邀约', desc: '渠道：邮件 · 模板：美妆新品邀约' },
    ],
    products: [
      { name: 'Vitamin C Essence', gmv: '$42,100', content: '12 videos' },
      { name: 'Face Mask', gmv: '$18,600', content: '3 live streams' },
      { name: 'Sunscreen', gmv: '$9,200', content: '6 videos' },
    ],
    coopProducts: '3 个',
    contentCount: '21 条',
  },
  {
    id: 'putri-sari',
    initial: 'P',
    color: '#8b5cf6',
    name: 'Putri Sari',
    handle: '@putri.home',
    country: '印尼 Indonesia',
    category: '家居 Home',
    followers: '96.4万',
    gmv30: 'Rp 128亿',
    hasEmail: true,
    status: '已触达',
    statusKey: 'reached',
    favorited: false,
  },
  {
    id: 'aisha-noor',
    initial: 'A',
    color: '#0ea5e9',
    name: 'Aisha Noor',
    handle: '@aisha.style',
    country: '马来 Malaysia',
    category: '时尚 Fashion',
    followers: '58.2万',
    gmv30: 'RM 860万',
    hasEmail: false,
    status: '待触达',
    statusKey: 'pending',
    favorited: false,
  },
  {
    id: 'minh-anh',
    initial: 'M',
    color: '#10b981',
    name: 'Minh Anh',
    handle: '@minhanh.beauty',
    country: '越南 Vietnam',
    category: '美妆 Beauty',
    followers: '31.5万',
    gmv30: '₫ 2.1亿',
    hasEmail: true,
    status: '已寄样',
    statusKey: 'sample',
    favorited: true,
  },
  {
    id: 'somchai-k',
    initial: 'S',
    color: '#f59e0b',
    name: 'Somchai K.',
    handle: '@somchai.th',
    country: '泰国 Thailand',
    category: '数码 Digital',
    followers: '72.0万',
    gmv30: '฿ 42.6M',
    hasEmail: true,
    status: '已出单',
    statusKey: 'ordered',
    favorited: false,
  },
  {
    id: 'ana-cruz',
    initial: 'A',
    color: '#ef4444',
    name: 'Ana Cruz',
    handle: '@ana.cruz.ph',
    country: '菲律宾 Philippines',
    category: '美妆 Beauty',
    followers: '18.9万',
    gmv30: '₱ 12.4M',
    hasEmail: true,
    status: '黑名单候选',
    statusKey: 'blacklist',
    favorited: false,
    highlightRow: true,
  },
  {
    id: 'wei-lin',
    initial: 'W',
    color: '#6366f1',
    name: 'Wei Lin',
    handle: '@weilin.sg',
    country: '新加坡 Singapore',
    category: '生活方式 Lifestyle',
    followers: '24.3万',
    gmv30: '$ 186K',
    hasEmail: true,
    status: '已发布',
    statusKey: 'published',
    favorited: false,
  },
];
